import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "timeline-hours" }
const _hoisted_2 = { class: "hour-label" }

import { computed } from 'vue';

interface Props {
  startHour: number;
  endHour: number;
  hourWidth: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'a-employee-timeblock-timeline-header',
  props: {
    startHour: {},
    endHour: {},
    hourWidth: {}
  },
  setup(__props: any) {

const props = __props;

// Generate hours array (exclude the last hour label)
const hours = computed(() => {
  const result = [];
  for (let i = props.startHour; i < props.endHour; i++) {
    result.push(i);
  }
  return result;
});

// Position calculation
const getHourPosition = (hour: number): number => {
  return (hour - props.startHour) * props.hourWidth;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hours.value, (hour) => {
      return (_openBlock(), _createElementBlock("div", {
        key: hour,
        class: "hour-marker",
        style: _normalizeStyle({ left: `${getHourPosition(hour)}px` })
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(hour) + ":00", 1)
      ], 4))
    }), 128))
  ]))
}
}

})